import React from "react";
import axios from "axios";
import moment from "moment";
import ReactTooltip from "react-tooltip";
import { Link } from "react-router";
import cx from "classnames";

import ChapterIndex from "../../components/ChapterIndex";
import { downloadFile } from "../../functions.js";

export default class CoursesInvoices extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            invoices: null,
            isPopup: props?.isPopup === true,
            your_reference: null,
            openInvoicelines: []
        };
    }

    componentDidMount = () => {
        this.getInitialData();
    };

    getInitialData = () => {
        // Get competenceprofile data to choose from and the course data itself
        axios
            .all([axios.get("/v1/courses/" + this.props.params.itemID + "/"), axios.get("/v1/courses/" + this.props.params.itemID + "/invoices/")])
            .then(
                axios.spread((course, invoices) => {
                    this.setState({
                        your_reference: `${course.data.id} - ${course.data.your_reference}`,
                        invoices: invoices.data.results
                    });
                })
            )
            .catch((error) => {
                console.log(error);
            });
    };

    toggleInvoiceLine = (key) => {
        let checkArray = this.state.openInvoicelines;

        var i = checkArray.indexOf(key);
        if (i !== -1) {
            checkArray.splice(i, 1);
        } else {
            checkArray.push(key);
        }
        this.setState({
            openInvoicelines: checkArray
        });
    };

    render = () => {
        let invoiceDetails = [];
        if (this.state.invoices === null) {
            invoiceDetails.push(
                <tr key={"eventdetails-loading"}>
                    <td colSpan="5">Factuurregels ophalen...</td>
                </tr>
            );
        } else if (this.state.invoices.length == 0) {
            invoiceDetails.push(
                <tr key={"eventdetails-loading"}>
                    <td colSpan="5">Er zijn nog geen factuurregels voor deze cursus</td>
                </tr>
            );
        } else {
            this.state.invoices.forEach((invoice, index) => {
                if (invoice.invoice_number) {
                    // Invoice is final, offer a download
                    invoiceDetails.push(
                        <tr key={`invoice-${index}`}>
                            <td>{invoice.invoice_number}</td>
                            <td className="link link--blue" onClick={() => downloadFile(invoice.invoice_url)}>
                                <strong>Factuur</strong>
                                <i className="fa fa-download" />
                            </td>
                            <td
                                onClick={(e) => {
                                    e.stopPropagation();
                                    if (!invoice.attachment?.available) return;
                                    downloadFile(invoice.attachment?.url);
                                }}
                                data-tip={!invoice.attachment?.available ? true : undefined}
                                data-for={!invoice.attachment?.available ? "invoice-attachment" : undefined}
                                className={`${invoice.attachment?.available ? "link link--blue" : "attachment-download-disabled"}`}
                            >
                                <strong>Factuurspecificatie</strong>
                                <i className={`${invoice.attachment?.available ? "fa fa-download" : "fa fa-download attachment-download-disabled"}`} />

                                {!invoice.attachment?.available && (
                                    <ReactTooltip delayShow={125} delayHide={125} id="invoice-attachment" effect="solid">
                                        De factuurspecificatie is beschikbaar voor facturen die definitief zijn en zijn aangemaakt na 17 oktober 2023.
                                    </ReactTooltip>
                                )}
                            </td>
                            <td colSpan="2" align="right" width="120">
                                {moment(invoice.invoice_date).format("DD-MM-YYYY")}
                            </td>
                        </tr>
                    );
                } else {
                    // Invoice is in concept
                    invoiceDetails.push(
                        <tr key={`invoice-${index}`}>
                            <td colSpan="4">
                                <h2>Nog te factureren</h2>
                            </td>
                        </tr>
                    );
                }

                let counter = 0;
                invoice.lines.forEach((line, lineIndex) => {
                    let quantity = line.line_items.filter((item) => item.course === this.props.params.itemID);

                    if (quantity.length > 0 && line.synchronized) {
                        let checkKey = `invoice-line-${index}-${lineIndex}`;
                        invoiceDetails.push(
                            <tr key={checkKey} onClick={(e) => this.toggleInvoiceLine(checkKey)} className="pointer">
                                <td width="50">{quantity.length}x</td>
                                <td colSpan="2">{line.description}</td>
                                <td align="right" width="120">
                                    &euro; {(line.unit_price * quantity.length).toFixed(2)}
                                </td>
                            </tr>
                        );

                        if (this.state.openInvoicelines.includes(checkKey))
                            line.line_items.forEach((item, itemIndex) => {
                                if (item.course === this.props.params.itemID) {
                                    invoiceDetails.push(
                                        <tr key={`invoice-lineitems-${index}-${lineIndex}-${itemIndex}`}>
                                            <td width="50"></td>
                                            <td className="lighter" colSpan="2">
                                                {item.description}
                                            </td>
                                            <td className="lighter" align="right">
                                                &euro; {line.unit_price}
                                            </td>
                                        </tr>
                                    );
                                }
                            });
                        counter++;
                    }
                });

                if (counter === 0) {
                    invoiceDetails.push(
                        <tr key={"invoice-line-noresults"}>
                            <td colSpan="4">Deze factuur wacht nog op synchronisatie of bevat geen specifieke regels voor deze cursus...</td>
                        </tr>
                    );
                }
                counter = 0;

                invoiceDetails.push(
                    <tr key={`invoice-line-${index}-spacer`}>
                        <td colSpan="5">&nbsp;</td>
                    </tr>
                );
            });
        }

        return (
            <div>
                {this.state?.isPopup !== true && (
                    <div className="section-top">
                        <div className="breadcrumbs">
                            <Link to={"/courses"}>Cursussen</Link>
                        </div>
                        <h1>
                            <strong>{this.state.your_reference || "Laden..."}</strong>
                        </h1>
                    </div>
                )}

                <div className="row">
                    {this.state?.isPopup !== true && (
                        <div className="col-3 mt-4">
                            <ChapterIndex
                                chapters={[
                                    { title: "Cursisten", link: "/courses/edit/" + this.props.params.itemID + "/students" },
                                    { title: "Cursusgegevens", link: "/courses/edit/" + this.props.params.itemID + "/details" },
                                    { title: "Downloads", link: "/courses/edit/" + this.props.params.itemID + "/downloads" },
                                    { title: "Facturatie", link: "/courses/edit/" + this.props.params.itemID + "/invoices" }
                                ]}
                                isDirty={this.state.dirtyForm}
                                activeChapter={4}
                                {...this.props}
                            />
                        </div>
                    )}
                    <div className={cx(this.state?.isPopup !== true ? "col-9" : "col-12", "mt-4")}>
                        {this.state?.isPopup !== true && <h2 className="h1 mb-3">Facturatie</h2>}
                        <p>Hieronder vind je de facturen die betrekking hebben op deze cursus.</p>

                        <div className="mt-3 mb-5">
                            <table className="table table-hover">
                                <tbody>{invoiceDetails}</tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    };
}
